/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';

//
export const initialState = {
  trendData: null,
  trendDataResponseId: 0,
  trendTabularUrl: '',
};
/**
 * All actions related to Trend Time widget feature are defined here
 */
export const trendTabularSlice = createSlice({
  name: SLICE.TREND_TABULAR,
  initialState,
  reducers: {
    getTrendData(state) {
      state.loading = true;
    },
    getTrendDataSucceeded(state, action) {
      state.loading = false;
      state.trendData = action?.payload;
      // a trend data request is completed, the visual reports that it is loaded
      state.trendDataResponseId = (state.trendDataResponseId ?? 0) + 1;
    },
    getTrendDataFailed(state) {
      state.loading = false;
      // a trend data request is completed, the visual reports that it is loaded
      state.trendDataResponseId = (state.trendDataResponseId ?? 0) + 1;
    },
    setTrendTabularUrl(state, action) {
      state.trendTabularUrl = action.payload;
    },
  },
});
//
export const { actions: trendTabularActions } = trendTabularSlice;
